

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Close } from '@mui/icons-material';

function MDDialog({ 
  open, 
  onClose, 
  title, 
  icon, 
  children, 
  maxWidth = "lg",
  actions,
  ...props 
}) {
  // Create a clone of the icon with white color
  const whiteIcon = icon ? React.cloneElement(icon, { sx: { color: 'white' } }) : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '10px',
          minHeight: '60vh',
          width: '95%',
          maxWidth: maxWidth === 'lg' ? '1200px' : '900px',
          overflow: 'hidden'
        }
      }}
      {...props}
    >
      <DialogTitle
        sx={{
          background: '#1565C8',
          color: 'white',
          padding: '16px 24px',
        }}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="center">
          <MDBox display="flex" alignItems="center" gap={2}>
            {icon && (
              <MDBox 
                display="flex" 
                alignItems="center"
                sx={{ 
                  '& svg': { 
                    color: 'white !important',
                    fontSize: '24px'
                  }
                }}
              >
                {whiteIcon}
              </MDBox>
            )}
            <MDTypography variant="h6" color="white">
              {title}
            </MDTypography>
          </MDBox>
          <IconButton 
            onClick={onClose} 
            size="small"
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            <Close />
          </IconButton>
        </MDBox>
      </DialogTitle>
      <DialogContent 
        dividers
        sx={{
          padding: '24px',
          '&.MuiDialogContent-dividers': {
            borderTop: '1px solid rgba(0, 0, 0, 0.12)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }
        }}
      >
        {children}
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px', justifyContent: 'flex-end' }}>
        {actions || (
          <MDButton onClick={onClose} color="info">
            Close
          </MDButton>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default MDDialog; 